/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InfoPageDto } from '../../models/info-page-dto';

export interface GetInfoPage$Params {
  slug: string;
}

export function getInfoPage(http: HttpClient, rootUrl: string, params: GetInfoPage$Params, context?: HttpContext): Observable<StrictHttpResponse<InfoPageDto>> {
  const rb = new RequestBuilder(rootUrl, getInfoPage.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InfoPageDto>;
    })
  );
}

getInfoPage.PATH = '/api/v1/info-pages/{slug}';
